import {
    styled,
    TextField,
    IconButton,
} from "@mui/material"

// Reusable Styled TextField for forms standard variant
export const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputLabel-root': {
        fontSize: '16px'
    },
    '& .MuiInput-root': {
        fontSize: '18px'
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: theme.palette.grey[400]
    },
    '& .MuiInput-underline:hover:before': {
        borderBottomColor: theme.palette.primary.main
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.primary.main
    },
    '& .MuiFormHelperText-root': {
        color: theme.palette.error.main,
        fontSize: '14px'
    },
}))

// Reusable Styled TextField for outlined inputs
export const StyledOutlinedTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputLabel-root': {
        fontSize: '16px'
    },
    '& .MuiOutlinedInput-root': {
        fontSize: '18px',
        '& fieldset': {
            borderColor: theme.palette.grey[400]
        },
        '&:hover fieldset': {
            borderColor: theme.palette.primary.main
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main
        },
    },
    '& .MuiFormHelperText-root': {
        color: theme.palette.error.main,
        fontSize: '14px'
    },
}))

// Reusable Styled IconButton for form inputs
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    '&:hover': {
        backgroundColor: theme.palette.action.hover
    },
    '& .MuiSvgIcon-root': {
        fontSize: '20px'
    },
}))